import { render, staticRenderFns } from "./addTrans.vue?vue&type=template&id=6e5711f9&scoped=true"
import script from "./addTrans.vue?vue&type=script&lang=js"
export * from "./addTrans.vue?vue&type=script&lang=js"
import style0 from "./addTrans.vue?vue&type=style&index=0&id=6e5711f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5711f9",
  null
  
)

export default component.exports